import { ZUS_SIGN_STATUS_LABELS, ZUS_SIGN_STATUS_VALUES } from '../../../constants-v2/bookkeeping/zus-declaration';
import declarationError from '../../../filters/zus/declaration-error';
import datePreviousMonth from '../../../procedures/date-previous-month';
import column from '../../abstract/column';
import form from '../../abstract/form';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';

export const signStatusOptions = {
  error: {
    label: ZUS_SIGN_STATUS_LABELS.ERROR,
    value: ZUS_SIGN_STATUS_VALUES.ERROR,
    color: 'danger',
  },
  wait: {
    label: ZUS_SIGN_STATUS_LABELS.WAIT_PACKAGE,
    value: ZUS_SIGN_STATUS_VALUES.WAIT,
    color: 'warning',
  },
  nostatus: {
    label: ZUS_SIGN_STATUS_LABELS.NOSTATUS_PACKAGE,
    value: ZUS_SIGN_STATUS_VALUES.NOSTATUS,
    color: '#c8c8c8',
  },
  success: {
    label: ZUS_SIGN_STATUS_LABELS.SUCCESS,
    value: ZUS_SIGN_STATUS_VALUES.SUCCESS,
    color: 'success',
  },
  control: {
    label: ZUS_SIGN_STATUS_LABELS.CONTROL_PACKAGE,
    value: ZUS_SIGN_STATUS_VALUES.CONTROL,
    color: 'warning',
  },
  investigation: {
    label: ZUS_SIGN_STATUS_LABELS.INVESTIGATION_PACKAGE,
    value: ZUS_SIGN_STATUS_VALUES.INVESTIGATION,
    color: 'warning',
  },
  errorPackage: {
    label: ZUS_SIGN_STATUS_LABELS.ERROR_PACKAGE,
    value: ZUS_SIGN_STATUS_VALUES.ERROR_PACKAGE,
    color: 'warning',
  },
};

export default {
  actions,
  topRightActions: {
    signer: {
      label: 'Pobierz Signer',
      icon: 'icon-download',
      handle: async ({}) => {
        if (navigator.userAgent.indexOf('Mac OS X') && import.meta.env.VITE_PUZZLETAX_SIGNER_MAC_URL) {
          window.open(import.meta.env.VITE_PUZZLETAX_SIGNER_MAC_URL, '_blank');
          window.open(import.meta.env.VITE_PUZZLETAX_SIGNER_MAC_INSTRUCTION_URL, '_blank');
          return;
        }
        window.open(import.meta.env.VITE_PUZZLETAX_SIGNER_URL, '_blank');
      },
    },
    create: {
      label: 'Dodaj zestaw',
      icon: 'icon-plus',
      handle: async ({ $router }) => await $router.push('/zus/packages/add'),
    },
  },
  api,
  modelName,
  sidebarData: {
    error: column({
      label: 'Błąd z ZUS',
      format: item => {
        return declarationError(item?.error);
      },
      size: 100,
    }),
    id: column({
      label: 'Identyfikator',
      size: 100,
    }),
  },
  columns: {
    document_index: column({
      label: 'Identyfikator paczki',
    }),
    created_at: column({
      label: 'Data utworzenia',
    }),
    sent_at: column({
      label: 'Data wysyłki',

    }),
    sent_by: column({
      label: 'Wysłane przez',
    }),
    status: column({
      label: 'Status wysyłki',
      format: item => {
        if (item.status) {
          return item.status;
        }
        if (item.task_index_package_in_zus) {
          return 'wait';
        }

        return 'nostatus';
      },
      options: signStatusOptions,
      component: 'value-status',
    }),
    _period: column({
      label: 'Okres',
      grid: false,
      sidebar: false,
      dateFormat: 'yyyy-MM',
      form: form({
        transformIf: ({ item: { year, month } }) => year && month,
        transform: ({ item: { year, month } }) => new Date(year, month - 1, 1),
        reverseTransform: undefined,
      }),
    }),

  },
  vars: vars({
    noItemsText: 'Brak zestawów',
    sidebarLabel: 'Podgląd zestawu',
    initItem: () => {
      const previousMonth = datePreviousMonth();
      return {
        year: previousMonth.getFullYear(),
        month: previousMonth.getMonth() + 1,
      };
    },
    onSuccessSave: async ({ $router }) => await $router.push('/zus/packages'),
  }),
};
